<template>
<div class="chapter">
<div class="inner_page">
<p style="font-style: italic; page-break-before: always; text-align: justify">Priva di bellezza e di fortuna, la semplicissima Miss Jane Featherstone non è riuscita ad attirare nessun pretendente durante le sue tre Stagioni. Piuttosto che essere un peso per il fratello e la sua odiosa moglie, Miss Featherstone giura di accettare il primo uomo che le chiederà di sposarla, anche se ha sempre venerato un lord molto al di sopra delle sue possibilità...</p>
<p style="font-style: italic; text-align: justify">Lord Slade deve sposare una ereditiera per onorare il voto fatto in punto di morte al padre ed ha bisogno dell’aiuto di Miss Featherstone per corteggiare la sua bella cugina. Dopo la rabbia iniziale, Miss Featherstone accetta il suo piano, dicendogli che lo fa perché ammira il suo curriculum parlamentare di legislazione umanitaria e la sua riverenza per la verità. Ma più sta con le due cugine, più è attratto da Miss Featherstone. Che cosa deve fare un umo di parola? Infrangere il voto fatto a un padre amato – o seguire il suo cuore con Miss Featherstone?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?7946e7e8